import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext'
import { UserRole } from '../types/User';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  allowedRoles = [] 
}) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();
  const hasValidSessionUser =
    Boolean(user?._id) &&
    typeof user?.role === 'string' &&
    user.role.length > 0;

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-t-2 border-blue-500"></div>
      </div>
    );
  }

  if (!isAuthenticated || !hasValidSessionUser) {
    return (
      <Navigate to="/login" state={{ from: location.pathname }} replace />
    );
  }

  // Check if role-based access is required and user has permission
  if (allowedRoles.length > 0 && user && !allowedRoles.includes(user.role as UserRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
